/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%]{background-color:#0080ff;color:#fff}.modal-body[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{border:0}.modal-header[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]{background:transparent;border:0;outline:none;cursor:pointer;line-height:1em}.modal-header[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:1.5em;color:#fff}"];
export { styles as styles };
//# sourceMappingURL=generic-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/generic-modal/generic-modal.component.scss.shim.ngstyle.js
// module id = 1100
// module chunks = 26 27 28